module.exports = __webpack_public_path__ + "static/media/1POLICY20.a1f80f64.jpg";